import type { RouteDefinition } from './router.js';

export const routes: RouteDefinition[] = [
    {
        path: '/',
        name: 'splash',
    },
    {
        path: '/match',
        name: 'match',
    },
    {
        path: '/manager',
        name: 'manager',
    },
    {
        path: '/manager/home',
        name: 'manager',
    },
    {
        path: '/manager/competitions',
        name: 'manager',
    },
    {
        path: '/manager/squad',
        name: 'manager',
    },
    {
        path: '/manager/fixtures',
        name: 'manager',
    },
    {
        path: '/manager/inbox',
        name: 'manager',
    },
    {
        path: '/manager/staff',
        name: 'manager',
    },
    {
        path: '/manager/transfers',
        name: 'manager',
    },
    {
        path: '/manager/intro',
        name: 'manager',
    },
    {
        path: '/manager/result',
        name: 'manager',
    },
    {
        path: '/manager/day-summary',
        name: 'manager',
    },
    {
        path: '/404',
        name: 'not-found',
    },
    {
        path: '/not-found',
        name: 'not-found',
    },
];

export function getRouteByName(name: string): RouteDefinition | undefined {
    return routes.find(r => r.name === name);
}
